import { useSelector } from "react-redux";
import { selectUser } from "../store/authSlice";

function Home() {
  const userData = useSelector(selectUser);

  // 根據 account_id 決定顯示的圖片
  const getImageSource = () => {
    if (userData?.account_id === 2) {
      return "/index-image.png";
    } else if (userData?.account_id === 3) {
      return "/index3-image.png";
    } else if (userData?.account_id === 4) {
      return "/index4-image.jpg";
    }
    return null;
  };

  const imageSrc = getImageSource();

  // 如果 account_id 是 1 或其他值，不顯示任何內容
  if (!imageSrc) {
    return null;
  }

  return (
    <div className="flex items-center justify-center h-full w-full p-4">
      <div className="relative w-full h-full flex items-center justify-center">
        <img
          src={imageSrc}
          alt=""
          className="max-w-full max-h-full w-auto h-auto object-contain rounded-lg shadow-2xl"
        />
      </div>
    </div>
  );
}

export default Home;